export const SAVE_TOKEN = 'SAVE_TOKEN'
export const GET_PRESIGNED_URL = 'GET_PRESIGNED_URL'
export const GET_URL_BY_KEY = 'GET_URL_BY_KEY'
export const GET_REQUEST_STATE = 'GET_REQUEST_STATE'
export const SAVE_REQUEST_STATE = 'SAVE_REQUEST_STATE'
export const SAVE_PRESIGNED_URL = 'GET_PRESIGNED_URL'
export const UPDATE_REQUEST_STATE = 'UPDATE_REQUEST_STATE'
export const UPDATE_SHOW_APP_REQUIREMENT = 'UPDATE_SHOW_APP_REQUIREMENT'
export const EXECUTE_DIALOG_ACTION = 'EXECUTE_DIALOG_ACTION'

export const saveToken = (token) => ({ type: SAVE_TOKEN, token })
export const getPreSignedURL = () => ({ type: GET_PRESIGNED_URL })
export const getURLByKey = (body) => ({ type: GET_URL_BY_KEY, body })
export const getRequestState = () => ({ type: GET_REQUEST_STATE })
export const updateRequestState = (body) => ({ type: UPDATE_REQUEST_STATE, body })
export const saveRequestState = (requestState) => ({ type: SAVE_REQUEST_STATE, requestState })
export const savePreSignedURL = (presignedURL) => ({ type: SAVE_PRESIGNED_URL, presignedURL })
export const updateShowAppRequirement = (show) => ({ type: UPDATE_SHOW_APP_REQUIREMENT, show })
export const executeDialogAction = (data) => ({ type: EXECUTE_DIALOG_ACTION, data })